import { createApp } from "vue";
import App from "./App.vue";
import mitt from "mitt";
import { createStore } from "./util/store";
import { validations } from "./util/validationRules";

const emitter = mitt();

const appElement = document.querySelector("#app");
const subscriptionType = appElement.getAttribute("data-subscriptionType");
const initCulture = appElement.getAttribute("data-culture");
console.log("init");
fetch("/umbraco/api/signup/GetSignupTextItems/?dictionaryKey=signupflow").then((response) => response.json()).then((dictionary) => {
  fetch(`/umbraco/api/signup/GetPrice?segment=${subscriptionType}&campaignCode=&culture=${initCulture}`).then((response) => response.json()).then((priceData) => {
    const app = createApp(App);
    const store = createStore(dictionary, priceData);
    app.config.globalProperties.emitter = emitter;
    app.config.globalProperties.store = store;
    app.config.globalProperties.validations = validations(store);
    app.config.globalProperties.merges = window.newMemberAppMerges ?? {};
    app.mount("#app");
  });
});
